import { render } from "./ReportChallengeComponent.vue?vue&type=template&id=ca9cb31e"
import script from "./ReportChallengeComponent.vue?vue&type=script&lang=js"
export * from "./ReportChallengeComponent.vue?vue&type=script&lang=js"

import "./ReportChallengeComponent.vue?vue&type=style&index=0&id=ca9cb31e&lang=scss"
script.render = render

export default script